import { formatDuration } from '@/lib/format'
import { useNow } from '@/lib/useNow'

export interface CountdownProps {
  /** Unix ms. */
  target: number
  /** Rendered once the target has passed. */
  done?: string
  className?: string
}

/** A live "2h 43m" to a server timestamp. */
export function Countdown({ target, done, className = '' }: CountdownProps) {
  const now = useNow(1000)
  const left = target - now
  if (left <= 0) return <span className={className}>{done ?? '0s'}</span>
  return <span className={`soc-num ${className}`}>{formatDuration(left)}</span>
}
